import React from 'react';

export const AssessmentsReportingContext = React.createContext({
    loading: false,
    error: null,
    load: () => Promise.reject(new Error('Not implemented')),
    data: {},
});

export default AssessmentsReportingContext;
